<template>
  <!-- 添加装柜配载单 -->
  <div class="jy-form-container">
    <!-- 按钮组 -->
    <div class="button-ground">
      <el-button
        class="jy-button active"
        @click="addOrUpdateEntruckDetail"
        >保存</el-button
      >
<!--      <el-button-->
<!--        class="jy-button"-->
<!--        @click="addOrUpdateEntruckDetail"-->
<!--        >补录保存</el-button-->
<!--      >-->
      <el-button  class="jy-button" @click="onOutbound('confirm')">出库确认</el-button>
      <el-button  class="jy-button" @click="onOutbound('cancel')"
        >取消出库</el-button
      >
<!--      <el-button  class="jy-button">打印拣货单</el-button>-->
    </div>
    <div class="form-line"></div>
    <!-- 运输信息 -->
    <div class="jy-line-container">
      <AngleDouble title="运输信息">
        <el-form
          :model="baseInfoForm"
          :rules="baseInfoRules"
          label-width="150px"
          label-position="right"
        >
          <el-row :gutter="gutter">
            <el-col :span="span">
              <el-form-item label="配载编号：" class="jy-form-input">
                <el-input
                  disabled
                  class="jy-form-input"
                  v-model="baseInfoForm.number"
                  placeholder="自动生成"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="span">
              <el-form-item
                label="装柜日期："
                prop="entruckDate"
                class="jy-form-time"
              >
                <el-date-picker
                  value-format="yyyy-MM-dd HH:mm:ss"
                  v-model="baseInfoForm.entruckDate"
                  type="datetime"
                />
              </el-form-item>
            </el-col>
            <el-col :span="span">
              <el-form-item
                label="柜号/航班号："
                prop="entruckNo"
                class="jy-form-input"
              >
                <el-input
                  class="jy-form-input"
                  v-model.trim="baseInfoForm.entruckNo"
                  placeholder=""
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="span">
              <el-form-item
                label="是否整柜："
                prop="wholeCabinetType"
                class="jy-form-select"
              >
                <el-select
                  v-model="baseInfoForm.wholeCabinetType"
                  placeholder="请选择"
                  clearable
                  @visible-change="visibleChange($event, 1)"
                  @change="
                    onSelect(
                      $event,
                      wholeCabinetTypeOptions,
                      ['wholeCabinetTypeConfDictId', 'wholeCabinetType'],
                      ['confDictId', 'val']
                    )
                  "
                >
                  <el-option
                    v-for="(item, index) in wholeCabinetTypeOptions"
                    :key="index"
                    :label="item.val"
                    :value="item.confDictId"
                  />
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="span">
              <el-form-item
                label="柜型："
                prop="cabinetType"
                class="jy-form-select"
              >
                <el-select
                  v-model="baseInfoForm.cabinetType"
                  placeholder="请选择"
                  clearable
                  @visible-change="visibleChange($event, 2)"
                  @change="
                    onSelect(
                      $event,
                      cabinetTypeOptions,
                      ['cabinetTypeConfDictId', 'cabinetType'],
                      ['confDictId', 'val']
                    )
                  "
                >
                  <el-option
                    v-for="(item, index) in cabinetTypeOptions"
                    :key="index"
                    :label="item.val"
                    :value="item.confDictId"
                  />
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="span">
              <el-form-item
                label="柜量："
                prop="cabinetQuantity"
                class="jy-form-input"
              >
                <el-input
                  type="number"
                  class="jy-form-input"
                  v-model="baseInfoForm.cabinetQuantity"
                  placeholder=""
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="span">
              <el-form-item
                  label="提单号："
                  prop="takeOrderNumber"
                  class="jy-form-input"
              >
                <el-input
                    class="jy-form-input"
                    v-model.trim="baseInfoForm.takeOrderNumber"
                    placeholder=""
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="span">
              <el-form-item
                label="目的国家："
                prop="areaCountry"
                class="jy-form-select"
              >
                <el-select
                  v-model="baseInfoForm.areaCountry"
                  placeholder="请选择"
                  @visible-change="visibleChange($event, 3)"
                  @change="
                    onSelect(
                      $event,
                      areaCountryOptions,
                      ['areaCountryId', 'areaCountry'],
                      ['areaCountryId', 'chineseName']
                    )
                  "
                  clearable
                  filterable
                >
                  <el-option
                    v-for="(item, index) in areaCountryOptions"
                    :key="index"
                    :label="item.chineseName"
                    :value="item.areaCountryId"
                  />
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="span">
              <el-form-item
                  label="装柜仓库："
                  class="jy-form-select"
                  prop="entruckStorageName"
              >
                <el-select
                    v-model="baseInfoForm.entruckStorageName"
                    placeholder="请选择"
                    @visible-change="visibleChange($event, 7)"
                    @change="
                    onSelect(
                      $event,
                      storageNameOptions,
                      ['entruckStorageId', 'entruckStorageName'],
                      ['storageId', 'storageName']
                    )
                  "
                    clearable
                >
                  <el-option
                      v-for="(item, index) in storageNameOptions"
                      :key="index"
                      :label="item.storageName"
                      :value="item.storageId"
                  />
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="span">
              <el-form-item
                  label="到达仓库："
                  class="jy-form-select"
                  prop="arrivalStorageName"
              >
                <el-select
                    v-model="baseInfoForm.arrivalStorageName"
                    placeholder="请选择"
                    @visible-change="visibleChange($event, 8)"
                    @change="
                    onSelect(
                      $event,
                      storageNameOptions,
                      ['arrivalStorageId', 'arrivalStorageName'],
                      ['storageId', 'storageName']
                    )
                  "
                    clearable
                >
                  <el-option
                      v-for="(item, index) in storageNameOptions"
                      :key="index"
                      :label="item.storageName"
                      :value="item.storageId"
                  />
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="span">
              <el-form-item
                  label="起运港："
                  prop="startPort"
                  class="jy-form-input"
              >
                <el-input
                    class="jy-form-input"
                    v-model="baseInfoForm.startPort"
                    placeholder=""
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="span">
              <el-form-item
                  label="目的港："
                  prop="endPort"
                  class="jy-form-input"
              >
                <el-input
                    class="jy-form-input"
                    v-model="baseInfoForm.endPort"
                    placeholder=""
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="span">
              <el-form-item
                  label="SO编号："
                  prop="soNumber"
                  class="jy-form-input"
              >
                <el-input
                    class="jy-form-input"
                    v-model.trim="baseInfoForm.soNumber"
                    placeholder=""
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="span">
              <el-form-item
                  label="船/航空公司："
                  prop="shipAirlinesName"
                  class="jy-form-select"
              >
                <el-select
                    v-model="baseInfoForm.shipAirlinesName"
                    placeholder="请选择"
                    @visible-change="visibleChange($event, 4)"
                    @change="
                    onSelect(
                      $event,
                      shipAirlinesOptions,
                      ['shipAirlinesId', 'shipAirlinesName'],
                      ['id', 'companyName']
                    )
                  "
                    clearable
                    filterable
                >
                  <el-option
                      v-for="(item, index) in shipAirlinesOptions"
                      :key="index"
                      :label="item.companyName"
                      :value="item.id"
                  />
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="span">
              <el-form-item label="船名/航次：" class="jy-form-input">
                <el-input
                    class="jy-form-input"
                    v-model.trim="baseInfoForm.voyageName"
                    placeholder=""
                ></el-input>
              </el-form-item>
            </el-col>

            <el-col :span="span">
              <el-form-item label="ETD：" prop="etd" class="jy-form-input">
                <el-date-picker
                    value-format="yyyy-MM-dd HH:mm:ss"
                    v-model="baseInfoForm.etd"
                    type="datetime"
                />
              </el-form-item>
            </el-col>
            <el-col :span="span">
              <el-form-item label="ETA：" prop="eta" class="jy-form-input">
                <el-date-picker
                    value-format="yyyy-MM-dd HH:mm:ss"
                    v-model="baseInfoForm.eta"
                    type="datetime"
                />
              </el-form-item>
            </el-col>
            <el-col :span="span">
              <el-form-item label="ETB：" class="jy-form-input">
                <el-date-picker
                    value-format="yyyy-MM-dd HH:mm:ss"
                    v-model="baseInfoForm.etb"
                    type="datetime"
                />
              </el-form-item>
            </el-col>
            <el-col :span="span">
              <el-form-item
                  label="运输方式："
                  prop="transportMethod"
                  class="jy-form-select"
              >
                <el-select
                    v-model="baseInfoForm.transportMethod"
                    placeholder="请选择"
                    @visible-change="visibleChange($event, 5)"
                    @change="
                    onSelect(
                      $event,
                      transportMethodOptions,
                      ['transportMethodConfDictId', 'transportMethod'],
                      ['confDictId', 'val']
                    )
                  "
                    clearable
                >
                  <el-option
                      v-for="(item, index) in transportMethodOptions"
                      :key="index"
                      :label="item.val"
                      :value="item.confDictId"
                  />
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="span">
              <el-form-item label="订舱合作商：" class="jy-form-select">
                <el-select
                    v-model="baseInfoForm.partnerChannleName"
                    placeholder="请选择"
                    @visible-change="visibleChange($event, 6)"
                    @change="
                    onSelect(
                      $event,
                      partnerChannleNameOptions,
                      ['partnerChannleId', 'partnerChannleName'],
                      ['id', 'partnerName']
                    )
                  "
                    clearable
                    filterable
                    remote
                    :remote-method="(val) => getPartnerChannleList(val)"
                >
                  <el-option
                      v-for="(item, index) in partnerChannleNameOptions"
                      :key="index"
                      :label="item.partnerName"
                      :value="item.id"
                  />
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="span">
              <el-form-item label="报关放行日期：" class="jy-form-time">
                <el-date-picker
                    value-format="yyyy-MM-dd HH:mm:ss"
                    v-model="baseInfoForm.customsClearanceDate"
                    type="datetime"
                />
              </el-form-item>
            </el-col>
            <el-col :span="span">
              <el-form-item label="起飞时间：" class="jy-form-time">
                <el-date-picker
                    value-format="yyyy-MM-dd HH:mm:ss"
                    v-model="baseInfoForm.flightDate"
                    type="datetime"
                />
              </el-form-item>
            </el-col>
            <el-col :span="span">
              <el-form-item label="创建时间：" class="jy-form-time">
                <el-date-picker
                    value-format="yyyy-MM-dd HH:mm:ss"
                    disabled
                    v-model="baseInfoForm.businessTime"
                    type="datetime"
                />
              </el-form-item>
            </el-col>
            <el-col :span="span">
              <el-form-item label="创建人：" class="jy-form-input">
                <el-input
                    disabled
                    class="jy-form-input"
                    v-model="baseInfoForm.businessUserName"
                    placeholder=""
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="span">
              <el-form-item label="操作人：" class="jy-form-input">
                <el-select
                    v-model="baseInfoForm.recorderUserName"
                    placeholder="请选择"
                    @visible-change="visibleChange($event, 9)"
                    @change="
                    onSelect(
                      $event,
                      recorderUserOptions,
                      ['recorderUserId', 'recorderUserName'],
                      ['userId', 'userName']
                    )
                  "
                    clearable
                    filterable
                    remote
                    :remote-method="(val) => getRecordUserList(val)"
                >
                  <el-option
                      v-for="(item, index) in recorderUserOptions"
                      :key="index"
                      :label="item.userName"
                      :value="item.userId"
                  />
                </el-select>


                <!--                <el-input-->
                <!--                    disabled-->
                <!--                    class="jy-form-input"-->
                <!--                    v-model="baseInfoForm.recorderUserName"-->
                <!--                    placeholder=""-->
                <!--                ></el-input>-->
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item label="备注：" class="jy-form-input">
                <el-input
                    class="jy-form-input"
                    v-model="baseInfoForm.remarks"
                    placeholder=""
                ></el-input>
              </el-form-item>
            </el-col>

          </el-row>
        </el-form>
      </AngleDouble>
    </div>
    <div class="jy-line-container">
      <AngleDouble title="装柜明细">
        <div class="button-ground">
          <el-button plain class="jy-button" @click="openShuttleA"
            >杂柜/包柜添加明细</el-button
          >
          <el-button plain class="jy-button" @click="onSingleSelectToAddWaybill"
            >单票添加运单</el-button
          >
          <el-button plain class="jy-button" @click="onDelEntruckNoInfo"
            >移除</el-button
          >
          <el-form
            :model="baseInfoForm"
            label-width="100px"
            label-position="right"
            style="margin-top: 15px"
          >
            <el-row :gutter="24">
              <el-col :span="6">
                <el-form-item label="柜量：" prop="cabinetQuantity">
                  <el-input
                    v-model="baseInfoForm.cabinetQuantity"
                    placeholder=""
                    readonly
                  ></el-input>
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>
        </div>
        <div class="table-ground">
          <el-table
            @selection-change="handleDispatchDetailsChange"
            class="jy-common-table"
            header-align="center"
            border
            stripe
            :highlight-current-row="true"
            style="width: 100%"
            :data="entruckDetailTable"
            :summary-method="getSummaries"
            show-summary
          >
            <el-table-column
              fixed="left"
              align="center"
              label="序号"
              type="index"
              width="60"
            ></el-table-column>
            <el-table-column align="center" type="selection" width="55" ></el-table-column>

            <el-table-column align="center" prop="boxNo" label="箱号">            </el-table-column>
            <el-table-column align="center" prop="waybillNumber" label="运单号">            </el-table-column>
            <el-table-column align="center" prop="closeNumber" label="合包单号">            </el-table-column>
            <el-table-column
              align="center"
              prop="memberId"
              label="会员代码"
            >
            </el-table-column>
            <el-table-column
              align="center"
              prop="userMemberName"
              label="会员名称"
            >            </el-table-column>
            <el-table-column align="center" prop="goodsName" label="产品">            </el-table-column>
            <el-table-column align="center" prop="packageName" label="包装">            </el-table-column>
            <el-table-column align="center" prop="closeBillCount" label="合包件数">            </el-table-column>
            <el-table-column align="center" prop="totalCount" label="件数">            </el-table-column>
            <el-table-column
              align="center"
              prop="totalWeight"
              label="重量"
            >            </el-table-column>
            <el-table-column
              align="center"
              prop="totalVolume"
              label="体积"
            >            </el-table-column>
            <el-table-column align="center" prop="specs" label="规格">      </el-table-column>
            <el-table-column
              align="center"
              prop="totalBillingWeight"
              label="结算重量"
            ></el-table-column>
            <el-table-column
              align="center"
              prop="businessDate"
              label="开单日期"
            ></el-table-column>
            <el-table-column
              align="center"
              prop="remarks"
              label="备注"
            ></el-table-column>
          </el-table>
        </div>
      </AngleDouble>
    </div>
    <div class="jy-line-container">
      <AngleDouble title="财务信息">
        <div class="button-ground">
          <el-button class="jy-button" type="primary" @click="onAddFeiYong"
            >添加费用</el-button
          >
          <el-button class="jy-button" @click="onCaiwuQdSp()">审核</el-button>
          <el-button class="jy-button" @click="onCaiwuQxSp()">取消审核</el-button>
        </div>
        <div class="table-ground" style="margin-top: 20px">
          <el-table
            class="jy-common-table"
            header-align="center"
            border
            stripe
            :highlight-current-row="true"
            style="width: 100%"
            :data="financialInformationTable"
            @selection-change="handleSelectionChange"
          >
            <el-table-column
              fixed="left"
              align="center"
              label="序号"
              type="index"
              width="60"
            ></el-table-column>
            <el-table-column fixed="left">
              <el-table-column type="selection" width="55" align="center" />
            </el-table-column>
            <el-table-column
                fixed="left"
              show-overflow-tooltip
              align="center"
              prop="itemCategoryName"
              label="费项类型"
              width="100"
            >
            </el-table-column>
            <el-table-column
                fixed="left"
              show-overflow-tooltip
              align="center"
              prop="itemServiceName"
              label="费项"
              width="100"
            >
            </el-table-column>
            <!-- <el-table-column
                fixed="left"
              show-overflow-tooltip
              align="center"
              prop="unitPrice"
              label="单价"
              width="60"
            >
            </el-table-column> -->
            <el-table-column
                fixed="left"
              show-overfslow-tooltip
              align="center"
              prop="amount"
              label="总价"
              width="60"
            >
            </el-table-column>
            <el-table-column
                fixed="left"
              show-overflow-tooltip
              align="center"
              prop="currency"
              label="币种"
              width="60"
            >
            </el-table-column>
            <el-table-column
                fixed="left"
              show-overflow-tooltip
              align="center"
              prop="objectStatus"
              label="结算对象类型"
              width="140"
            >
            </el-table-column>
            <el-table-column
                fixed="left"
              show-overflow-tooltip
              align="center"
              prop="objectName"
              label="结算对象"
              width="100"
            >
            </el-table-column>
            <el-table-column
                fixed="left"
              show-overflow-tooltip
              align="center"
              prop="paymentMethod"
              label="付款方式"
              width="100"
            >
            </el-table-column>
            <el-table-column
                fixed="left"
              show-overflow-tooltip
              align="center"
              prop="isPostingShow"
              label="审核状态"
                width="80"
            >
            </el-table-column>
            <el-table-column
                fixed="left"
              show-overflow-tooltip
              align="center"
              prop="remarks"
              label="备注"
            >
            </el-table-column>
            <el-table-column
                fixed="left"
              show-overflow-tooltip
              align="center"
              prop="createUser"
              label="操作人"
              width="80"
            >
            </el-table-column>
            <el-table-column
                fixed="left"
              show-overflow-tooltip
              align="center"
              prop="updateTime"
              label="操作时间"
            >
            </el-table-column>
            <el-table-column
              align="center"
              label="操作"
              fixed="right"
            >
              <template #default="scope">
                <el-button
                  v-if="pageStatus != 'readonly' && scope.row.isPosting == 0"
                  link
                  @click="onYsfyEditFun(scope, scope.$index)"
                  >编辑</el-button
                >
                <el-button
                    v-if="pageStatus != 'readonly' && scope.row.isPosting == 0"
                    link
                    @click="onCaiwuQdSp(scope)"
                >审核</el-button
                >
                <el-button
                    v-if="pageStatus != 'readonly' && scope.row.isPosting == 1"
                    link
                    @click="onCaiwuQxSp(scope)"
                >取消审核</el-button
                >
                <el-popconfirm
                  title="确定删除该行信息吗"
                  @confirm="delGoods(scope.$index)"
                  v-if="pageStatus != 'readonly' && scope.row.isPosting == 0"
                >
                  <template #reference>
                    <el-button link style="margin-left: 10px; margin-right: 10px;">删除</el-button>
                  </template>
                </el-popconfirm>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </AngleDouble>
    </div>
    <div class="jy-line-container">
      <AngleDouble title="附件信息">
        <commonFuJian :data="annexTable" ref="domCommonFuJian"></commonFuJian>
      </AngleDouble>
    </div>
    <!-- 取出运单 -->
    <Dialog
      width="1200px"
      :show="waybillShow"
      :title="'选择'"
      @onCancel="waybillCancel"
      @onConfirm="waybillConfirm"
      class="dialog-padding-container"
    >
      <shuttleFrame
        :searchData="searchDataA"
        :searchResult="searchResultA"
        :tableHead="tableHeadA"
        :filterData="filterDataA"
        @getSearch="getSearchA"
        :tableLeftData="tableLeftDataA"
        :leftPageData="leftPageDataA"
        @leftPageChange="leftPageChangeA"
        @filterTable="filterTableA"
        :pageStatus="pageStatus"
      ></shuttleFrame>
    </Dialog>
    <!--  批量添加运单 -->
    <Dialog
      :show="waybillnumberShow"
      class="dialog-padding-container"
      title="批量添加运单"
      @onCancel="addPayableCancel_A"
      @onConfirm="addPayableConfirm_A"
    >
      <el-form
        :model="addPLwaybillNumbers"
        label-width="150px"
        label-position="right"
      >
        <el-row :gutter="20">
          <el-col :span="24">
            <el-form-item label="运单号:">
              <el-input
                v-model="addPLwaybillNumbers.numbers"
                placeholder="请输入或者粘贴运单号,多个运单号用空格或者逗号','隔开"
                type="textarea"
                :rows="16"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </Dialog>
    <!--  添加/编辑费用 -->
    <Dialog
      :show="dialogVisible"
      class="dialog-padding-container"
      :title="feiYongTit"
      @onCancel="addPayableCancel"
      @onConfirm="addPayableConfirm"
    >
      <el-form
        :model="addPayableInfo"
        :rules="addPayableInfoRules"
        label-width="150px"
        label-position="right"
      >
        <el-row :gutter="20">
          <el-col :span="18">
            <objectComponentsN
              label="结算对象："
              :objectStatus="addPayableInfo.objectStatus"
              :objectStatusId="addPayableInfo.objectStatusConfDictId"
              :objectName="addPayableInfo.objectName"
              :objectNameId="addPayableInfo.objectNameId"
              :isJyForm="false"
              :objectStatusDataList="objectStatusDataList"
              :objectNameOptions="objectNameOptions"
              @returnData="returnObjectData"
            ></objectComponentsN>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="20">
            <el-form-item label="费项：" prop="itemCategoryId">
              <div style="display: flex; width: 60%;">
                <el-select
                  clearable
                  v-model="addPayableInfo.itemCategoryId"
                  @visible-change="addPayableVisibleChange($event, 3)"
                  @change="onSelectItemCategoryName"
                  placeholder="费项类型"
                >
                  <el-option
                    v-for="(item, index) in itemcategoryTypeOptions"
                    :key="index"
                    :label="item.categoryName"
                    :value="item.itemCategoryId"
                  />
                </el-select>
                <el-select
                  v-model="addPayableInfo.itemServiceId"
                  :disabled="!addPayableInfo.itemCategoryId"
                  placeholder="费项"
                  @visible-change="addPayableVisibleChange($event, 4)"
                  @change="onSelectItemServiceName"
                  style="margin-left: 10px"
                  clearable
                >
                  <el-option
                    v-for="(item, index) in itemServiceOptions"
                    :key="index"
                    :label="item.title"
                    :value="item.itemServiceId"
                  />
                </el-select>
              </div>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="140">
          <el-col :span="8">
            <el-form-item label="金额：" prop="amount">
              <el-input
                v-model="addPayableInfo.amount"
                placeholder=""
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="结算币种：" prop="currency">
              <el-select
                  clearable
                  v-model="addPayableInfo.currency"
                  placeholder="请选择"
                  @visible-change="addPayableVisibleChange($event, 5)"
                  @change="changeCurrency"
              >
                <el-option
                    v-for="(item, index) in currencyOptions"
                    :key="index"
                    :label="item.cnName"
                    :value="item.cnName"
                />
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">

        </el-row>
        <el-row :gutter="20">
          <el-col :span="8">
            <el-form-item label="付款方式：" prop="paymentMethodConfDictId">
              <el-select
                clearable
                v-model="addPayableInfo.paymentMethodConfDictId"
                placeholder="请选择"
                @visible-change="addPayableVisibleChange($event, 6)"
                @change="onSelectPaymentMethod"
              >
                <el-option
                  v-for="(item, index) in paymentMethodOptions"
                  :key="index"
                  :label="item.val"
                  :value="item.confDictId"
                />
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="18">
            <el-form-item label="备注：">
              <el-input
                v-model="addPayableInfo.remarks"
                placeholder=""
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="20">
            <el-form-item label="上传：">
              <uploadimgs
                @input="dialogChangeFileList"
                :fileNameLists="dialogFileNameLists"
                :limit="99"
                listType="picture-card"
              ></uploadimgs>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </Dialog>

    <!-- 单票添加运单 -->
    <MessageBox
      :show="singleSelectToAddWaybillVisible"
      inputType="input"
      formTitle="运单号"
      @onMessageBoxCancel="onCancelSingleSelectToAddWaybill"
      @onMessageBoxConfirm="onConfirmSingleSelectToAddWaybill"
    >
    </MessageBox>
  </div>
</template>
<script>
import { Api } from "@/assets/js/api";
import utils from "@/assets/js/tool";
import paging from "@/components/pagings.vue";
import MathNumBer from "@/assets/js/MathNumBer";
import commonFuJian from "@/components/fuJian/index.vue";
// 详情页排版通用组件
import AngleDouble from '@/components/details/angleDouble.vue';
import shuttleFrame from '@/components/shuttleFrame/index.vue';
import uploadimgs from "@/components/uploadImgs/index.vue";
import MessageBox from "@/components/messageBox/index.vue";
import { Message as ElMessage, MessageBox as ElMessageBox } from 'element-ui'
import objectComponentsN from '@/components/objectComponents/indexNew.vue'

export default {
  name: "EntruckAdd",
  inject: ["reload"],
  components: {
    shuttleFrame,
    uploadimgs,
    MessageBox,
    commonFuJian,
    ElMessage,
    ElMessageBox,
    AngleDouble,
    objectComponentsN
  },
  data() {
    return {
      gutter: 12,
      span: 6,
      totlaList: [
        "totalCount",
        "totalGrossWeight",
        "totalGrossVolume",
        "totalSettlementWeight",
        "totalSettlementVolume"
      ],
      pageStatus: "create",
      domCommonFuJian: null,
      annexTable: [],
      mainId: "",
      recorderUserOptions: [],
      // 表单数据
      baseInfoObj: {
        entruckId: "",
        number: "",
        entruckDate: "",
        entruckNo: "",
        wholeCabinetTypeConfDictId: 0,
        wholeCabinetType: "",
        cabinetTypeConfDictId: "",
        cabinetType: "",
        cabinetQuantity: "",
        areaCountryId: "",
        areaCountry: "",
        startPort: "",
        endPort: "",
        takeOrderNumber: "",
        shipAirlinesId: "",
        shipAirlinesName: "",
        voyageName: "",
        soNumber: "",
        etd: "",
        eta: "",
        etb: "",
        transportMethodConfDictId: "",
        transportMethod: "",
        partnerChannleId: "",
        partnerChannleName: "",
        customsClearanceDate: "",
        customsCheckDate: "",
        shipmentDate: "",
        entruckStorageName: "",
        entruckStorageId: "",
        arrivalPortDate: "",
        touchPortDate: "",
        arrivalStorageId: "",
        arrivalStorageName: "",
        planIntoStorageTime: "",
        intoEndStorageTime: "",
        businessTime: "",
        businessUserName: "",
        recorderUserId: "",
        recorderUserName: "",
        flightDate: "",
        remarks: "",
        outStorageStatus: "",
        outStorageStatusName: ""
      },
      baseInfoForm: {
        entruckId: "",
        number: "",
        entruckDate: "",
        entruckNo: "",
        wholeCabinetTypeConfDictId: 0,
        wholeCabinetType: "",
        cabinetTypeConfDictId: "",
        cabinetType: "",
        cabinetQuantity: "",
        areaCountryId: "",
        areaCountry: "",
        startPort: "",
        endPort: "",
        takeOrderNumber: "",
        shipAirlinesId: "",
        shipAirlinesName: "",
        voyageName: "",
        soNumber: "",
        etd: "",
        eta: "",
        etb: "",
        transportMethodConfDictId: "",
        transportMethod: "",
        partnerChannleId: "",
        partnerChannleName: "",
        customsClearanceDate: "",
        customsCheckDate: "",
        shipmentDate: "",
        entruckStorageName: "",
        entruckStorageId: "",
        arrivalPortDate: "",
        touchPortDate: "",
        arrivalStorageId: "",
        arrivalStorageName: "",
        planIntoStorageTime: "",
        intoEndStorageTime: "",
        businessTime: "",
        businessUserName: "",
        recorderUserId: "",
        recorderUserName: "",
        flightDate: "",
        remarks: "",
        outStorageStatus: "",
        outStorageStatusName: ""
      },
      backUpBaseInfoForm: {},
      baseInfoRules: {
        // entruckDate: [{required: true, message: "必填", trigger: "blur"}],
        // wholeCabinetType: [{required: true, message: "必填", trigger: "blur"}],
        // cabinetType: [{required: true, message: "必填", trigger: "blur"}],
        // endPort: [{required: true, message: "必填", trigger: "blur"}],
        // transportMethod: [{required: true, message: "必填", trigger: "blur"}],
        // areaCountry: [{required: true, message: "必填", trigger: "blur"}],
        // entruckStorageName: [{required: true, message: "必填", trigger: "blur"}],
        // arrivalStorageName: [{required: true, message: "必填", trigger: "blur"}]
      },
      // 下拉框数据
      wholeCabinetTypeOptions: [],
      cabinetTypeOptions: [],
      areaCountryOptions: [],
      shipAirlinesOptions: [],
      transportMethodOptions: [],
      partnerChannleNameOptions: [],
      storageNameOptions: [],
      entruckDetailTable: [],
      financialInformationTable: [],
      addPLwaybillNumbers: {
        numbers: ""
      },
      addPayableInfo: {
        financeItemServiceId: "",
        itemCategoryId: "",
        itemCategoryName: "",
        itemServiceId: "",
        itemServiceName: "",
        unitPrice: "",
        amount: "",
        currency: "",
        currencyId: "",
        objectStatusConfDictId: "",
        objectStatus: "",
        objectName: "",
        objectNameId: "",
        objectNumber: "",
        paymentMethodConfDictId: "",
        paymentMethod: "",
        remarks: "",
        createUser: "",
        updateTime: "",
        files: []
      },
      addPayableInfoRules: {
        objectStatusConfDictId: [{required: true, message: "必填", trigger: "change"}],
        itemCategoryId: [{required: true, message: "必填", trigger: "change"}],
        amount: [{required: true, message: "必填", trigger: "change"}],
        currency: [{required: true, message: "必填", trigger: "change"}],
        paymentMethodConfDictId: [{required: true, message: "必填", trigger: "change"}]
      },
      feiYongTit: "添加费用",
      dialogVisible: false,
      dialogFileNameLists: [],
      financialInformationIndex: 0,
      financialInformationTableObj:{
        financeItemServiceId: "", //财务费项id
        itemCategoryId: "", //费项类型id
        itemCategoryName: "", //费项类型
        itemServiceId: "", //费项id
        itemServiceName: "", //费项
        unitPrice: "", //单价
        amount: "", //总计金额
        currency: "", //币种
        currencyId: "",
        objectStatusConfDictId: "", //结算对象类型
        objectStatus: "", //结算对象类型名称
        objectName: "", //结算对象
        objectNameId: "",
        objectNumber: "", //结算对象编号
        paymentMethodConfDictId: "", //付款方式id
        paymentMethod: "", //付款方式
        remarks: "", //备注
        createUser: "", //操作人
        updateTime: "", //操作时间
        files: [],
      },
      backupFinancialInformationTable : {},

      objectStatusDataList: [],
      objectStatusOptions: [],
      currencyOptions: [],
      paymentMethodOptions: [],
      itemcategoryTypeOptions: [],
      itemServiceOptions: [],
      objectNameOptions: [],
      waybillnumberShow: false,
      waybillShow: false,
      dispatchDetailsMultipleSelection: [],
      // 查询的类型
      searchDataA: [
        {
          title: "开单开始日期",
          type: "datetime",
          key: "startTime",
          labelWidth: "100",
        },
        { title: "开单结束日期", type: "datetime", key: "endTime", labelWidth: "100" },
        { title: "运单号", type: "text", key: "waybillNumber", labelWidth: "60" },
        {
          title: "客户名称",
          type: "userMemberName",
          key: "userMemberName",
          labelWidth: "90",
        },
        { title: "客户ID", type: "hidden", key: "userMemberId", labelWidth: "90" },
        {
          title: "入仓仓库",
          type: "ajax",
          key: "intoStorageId",
          parms: {
            label: "storageName",
            value: "storageId",
          },
          labelWidth: "90",
          isAjax: true,
          ajaxParms: "storage_choose_list",
          ajaxType: 1,
          options: [],
        },
        { title: "打包批次号", type: "text", key: "number", labelWidth: "90" },
        { title: "合包单号", type: "text", key: "closeNumber", labelWidth: "90" },

      ],

      searchResultA: {
        number: "",
        userMemberName: "",
        userMemberId: "",
        intoStorageId: "",
        startTime: "",
      },

      tableHeadA : [
        { name: "number", label: "打包批次号", width: 120, isShow: true },
        { name: "closeNumber", label: "合包单号", width: 120, isShow: true },
        { name: "boxNo", label: "箱号", width: 120, isShow: true },
        { name: "waybillNumber", label: "运单号", width: 120, isShow: true },
        { name: "memberId", label: "会员代码", width: 100, isShow: true },
        { name: "userMemberName", label: "会员名称", width: 100, isShow: true },
        { name: "goodsName", label: "产品", width: 60, isShow: true },
        { name: "closeBillCount", label: "合包件数", width: 60, isShow: true },
        { name: "totalCount", label: "件数", width: 60, isShow: true },
        { name: "totalWeight", label: "重量", width: 60, isShow: true },
        { name: "totalVolume", label: "体积", width: 60, isShow: true },
        { name: "businessDate", label: "开单日期", width: 100, isShow: true },
        { name: "remarks", label: "备注", isShow: true },
      ],
      filterDataA : [],
      tableLeftDataA : [],
      leftPageDataA: {
        page: 1,
        size: 20,
        total: 0,
      },
      singleSelectToAddWaybillVisible : false,
      isClickBtns: false,
      selectTabledataList : [],
    };
  },
  mounted() {
    this.windowResize();
    this.leftPageDataA.total = this.tableLeftDataA.length;
    this.annexTable = [];
    this.backupFinancialInformationTable = utils.relObjRam(this.financialInformationTableObj);
    window.addEventListener("resize", this.windowResize);
    this.getStorageDefault();
    const query = this.$route.query;
    const meta = this.$route.meta;

    //获取柜单详情
    let entruckId = query.entruckId;
    let pageType = query.pageType;
    if("create" !== pageType) {
      this.baseInfoForm.entruckId = entruckId;
      this.baseInfoObj.entruckId = entruckId;
      this.pageStatus = pageType;
      this.getDetailsData(entruckId);
    }



    // if (query.cache == "false" && meta.title == "添加装柜配载单") {
    //   utils.oldObjToNewObj(this.baseInfoForm, this.backUpBaseInfoForm);
    //   this.financialInformationTable = [];
    //   this.entruckDetailTable = [];
    //   this.annexTable = [];
    //   this.baseInfoForm.entruckDate = utils.getNowTime();
    //   this.getFeiXiangType();
    // }
  },
  watch: {


  },
  methods: {
    // 窗口大小变化时调整布局
    windowResize() {
      let clientWidth = document.body.clientWidth;
      this.span = clientWidth <= 1760 ? 8 : 6;
    },
    // 查询详情页数据  -- begin
    async getDetailsData(entruckId){
      let obj = {
        conditonKey: "entruckId",
        conditonVal: entruckId,
      };
      const loading = this.$loading({
        lock: true,
        text: "拼命加载中...",
        background: "rgba(255, 255, 255, 0)"
      });
      await this.onGetBaseInfo(obj);
      loading.close();
      await this.onGetEntruckDetailData(obj);
      await utils.jySleep();
      await this.onGetFinancialInformationData(obj);
      await this.onGetEntruckDetailFileData(obj);
    },
    getRecordUserList(val) {
      utils.getSelectData("down_list_user", 1, arrs).then((res) => {
        this.recorderUserOptions = res.arr;
      });
    },
    // 附件列表
    async onGetEntruckDetailFileData(obj){
      let params4 = {
        conditionReqs: [obj],
        number: "entruck_detail_file",
      };
      let arr = [];
      await Api.runReport(params4).then((res) => {
        if (res.status == 200) {
          const data = res.data;
          if (data.status == "success") {
            let result = data.result;
            const datas = result.datas;
            if (utils.jyCheckObjectType(datas) == "Array") {
              if (datas.length > 0) {
                datas.forEach((item) => {
                  arr.push({
                    fileName: item.fileName,
                    fileId: item.fileId,
                    documentType: item.documentType,
                    createTime: item.createTime,
                    operationUserName: item.operationUserName,
                    operationType: "UPDATE",
                  });
                });
              }
              this.annexTable = arr;
            }
          }
        }
      });
    },

    // 财务信息
    async onGetFinancialInformationData(obj){

      let params3 = {
        conditionReqs: [obj],
        number: "entruck_detail_finance",
      };
      let caiWuXinXiList = [];
      await Api.runReport(params3).then((res) => {
        const data = res.data;
        if (data.status == "success") {
          let result = data.result;
          const datas = result.datas;
          if (utils.jyCheckObjectType(datas) == "Array") {
            caiWuXinXiList = datas;
          }
        }
      });

      // 财务信息附件
      let params3_1 = {
        conditionReqs: [obj],
        number: "entruck_detail_finance_file",
      };
      let caiWuXinXiFuJianList = [];
      await Api.runReport(params3_1).then((res) => {
        const data = res.data;
        if (data.status == "success") {
          let result = data.result;
          const datas = result.datas;
          if (utils.jyCheckObjectType(datas) == "Array") {
            caiWuXinXiFuJianList = datas;
          }
        }
      });

      caiWuXinXiList.forEach((value, key) => {
        let arr = [];
        caiWuXinXiFuJianList.forEach((item, index) => {
          if (value.id == item.financeItemServiceId) {
            item.name = item.fileId;
            item.status = "success";
            arr.push(item);
          }
        });
        value.files = arr;
      });

      // 只为匹配出结算对象的id
      await utils.getSelectData("object_status", 3).then((res) => {
        const lists = res.arr;
        this.objectStatusDataList = lists;

        caiWuXinXiList.forEach((item) => {
          let arrs = lists.filter((itemA) => {
            return itemA.confDictId == item.objectStatusConfDictId;
          });
          let keyType = arrs[0].keyType;
          if (keyType == "customer:object_status") {
            // 会员
            utils.getSelectData("member_down_list", 9).then((res) => {
              let lists = res.arr;
              lists.forEach((itemB) => {
                if (itemB.userMemberName == item.objectName) {
                  item.objectNameId = itemB.userMemberId;
                }
              });
            });
          } else if (keyType == "department:object_status") {
            // 部门
            utils.getSelectData("storage_choose_list", 1).then((res) => {
              let lists = res.arr;
              lists.forEach((itemB) => {
                if (itemB.storageName == item.objectName) {
                  item.objectNameId = itemB.storageId;
                }
              });
            });
          } else if (keyType == "channel:object_status") {
            // 合作商
            utils.getSelectData("partner_channel_choose_list", 1).then((res) => {
              let lists = res.arr;
              lists.forEach((itemB) => {
                if (itemB.partnerName == item.objectName) {
                  item.objectNameId = itemB.id;
                }
              });
            });
          } else if (keyType == "employee:object_status") {
            // 员工
            utils.getSelectData("employee_choose_list", 1).then((res) => {
              let lists = res.arr;
              lists.forEach((itemB) => {
                if (itemB.objectName == item.objectName) {
                  item.objectNameId = itemB.objectId;
                }
              });
            });
          } else if (keyType == "ship_airlines:object_status") {
            // 航空公司
            utils.getSelectData("ship_airlines_choose_list", 1).then((res) => {
              let lists = res.arr;
              lists.forEach((itemB) => {
                if (itemB.companyName == item.objectName) {
                  item.objectNameId = itemB.id;
                }
              });
            });
          }
        });
      });

      this.financialInformationTable = JSON.parse(JSON.stringify(caiWuXinXiList));
    },
    // 装柜配载详情明细
    async onGetEntruckDetailData(obj){
      let params2 = {
        conditionReqs: [obj],
        number: "entruck_detail_item",
      };
      await Api.runReport(params2).then((res) => {
        if (res.status == 200) {
          const data = res.data;
          if (data.status == "success") {
            let result = data.result;
            const datas = result.datas;
            if (utils.jyCheckObjectType(datas) == "Array") {
              this.entruckDetailTable = datas;
            }
          }
        }
      });
    },
    // 装柜配载详情
    async onGetBaseInfo(obj){
      let params1 = {
        conditionReqs: [obj],
        number: "entruck_detail",
      };
      await Api.runReport(params1).then((res) => {
        if (res.status == 200) {
          const data = res.data;
          if (data.status == "success") {
            let result = data.result;
            const datas = result.datas;
            if (utils.jyCheckObjectType(datas) == "Array") {
              const obj = datas[0];
              // 基本信息
              utils.oldObjToNewObj(this.baseInfoForm, obj);
            }
          }
        }
      });
    },



    // 获取合计数据
    getSummaries(param) {
      return utils.utilsgetSummaries(param, this.totlaList);
    },

    // 获取默认仓库信息
    getStorageDefault() {
      utils.getSelectData("storage_choose_list", 1, [
        { conditonKey: "isDefault", conditonVal: "1" }
      ]).then((res) => {
        if (res.arr && res.arr.length > 0) {
          const obj = res.arr[0];
          this.baseInfoForm.entruckStorageName = obj.storageName;
          this.baseInfoForm.entruckStorageId = obj.storageId;
        }
      });
    },

    // 下拉框数据加载
    visibleChange(val, type) {
      if (val) {
        if (type == 1) {
          utils.getSelectData("whole_cabinet_type", 3).then((res) => {
            this.wholeCabinetTypeOptions = res.arr;
          });
        } else if (type == 2) {
          utils.getSelectData("cabinet_type", 3).then((res) => {
            this.cabinetTypeOptions = res.arr;
          });
        } else if (type == 3) {
          utils.getSelectData("", 2).then((res) => {
            this.areaCountryOptions = res.arr;
            console.info("国家", this.areaCountryOptions);
          });
        } else if (type == 4) {
          utils.getSelectData("ship_airlines_choose_list", 1).then((res) => {
            this.shipAirlinesOptions = res.arr;
          });
        } else if (type == 5) {
          utils.getSelectData("transport_method", 3).then((res) => {
            this.transportMethodOptions = res.arr;
          });
        } else if (type == 6) {
          utils.getSelectData("partner_channel_choose_list", 1).then((res) => {
            this.partnerChannleNameOptions = res.arr;
          });
        } else if (type == 7 || type == 8) {
          utils.getSelectData("storage_choose_list", 1).then((res) => {
            this.storageNameOptions = res.arr;
          });
        } else if (type == 9) {
          utils.getSelectData("down_list_user", 1).then((res) => {
            this.recorderUserOptions = res.arr;
          });
        }
      }
    },

    // 获取订舱合作商列表
    getPartnerChannleList(val) {
      let arrs = [{ conditonKey: "partnerName", conditonVal: val }];
      utils.getSelectData("partner_channel_choose_list", 1, arrs).then((res) => {
        this.partnerChannleNameOptions = res.arr;
      });
    },

    // 表单字段选择器联动
    onSelect(val, arr, type, select) {
      if (type[1]) {
        const obj = utils.jyIDGetContent(arr, select[0], val);
        if (obj) {
          this.baseInfoForm[type[1]] = obj[select[1]];
        }
      }
      this.baseInfoForm[type[0]] = val;
    },

    // 保存或更新装柜信息
    addOrUpdateEntruckDetail() {
      // if (!this.baseInfoForm.arrivalStorageName) {
      //   ElMessage({ message: "到达仓库必填", type: "error" });
      //   return false;
      // }
      // if (!this.baseInfoForm.entruckStorageName) {
      //   ElMessage({ message: "装柜仓库必填", type: "error" });
      //   return false;
      // }
      // if (!this.baseInfoForm.transportMethodConfDictId) {
      //   ElMessage({ message: "运输方式必填", type: "error" });
      //   return false;
      // }

      let params = Object.assign({}, this.baseInfoForm, {
        files: [...this.$refs.domCommonFuJian.annexTable, ...this.$refs.domCommonFuJian.DELFilesList],
        financeItems: this.financialInformationTable,
        items: this.entruckDetailTable.map(({ waybillNumber, ...rest }) => rest)
      });
      if("0"===params.shipAirlinesId)
        params.shipAirlinesId = "";
      if("0"===params.areaCountryId)
        params.areaCountryId = "";
      if("0"===params.arrivalStorageId)
        params.arrivalStorageId = "";
      if("0"===params.cabinetTypeConfDictId)
        params.cabinetTypeConfDictId = "";
      if("0"===params.partnerChannleId)
        params.partnerChannleId = "";
      if("0"===params.transportMethodConfDictId)
        params.transportMethodConfDictId = "";
      if("0"===params.wholeCabinetTypeConfDictId)
        params.wholeCabinetTypeConfDictId = "";

      if (this.pageStatus === "modify") {
        Api.updateBillTmsEntruck(params).then((res) => {
          if (res.status === 200) {
            const data = res.data;
            ElMessage({ message: data.message, type: data.status });
          }
        });
      } else {
        Api.addBillTmsEntruck(params).then((res) => {
          if (res.status === 200) {
            const data = res.data;
            this.$message.warning( data.message);
            // ElMessage({ message: data.message, type: data.status });
            if (data.status === "success") {
              bus.emit("refreshCurrent");
            }
          }
        });
      }
    },

    // 打开运单穿梭框
    openShuttleA() {
      this.waybillShow = true;
    },

    // 关闭运单穿梭框
    waybillCancel() {
      this.waybillShow = false;
    },

    // 确认选择运单
    waybillConfirm() {
      if (this.filterDataA.length > 0) {
        for (let i = 0; i < this.filterDataA.length; i++){
          let obj = this.filterDataA[i];
          if(obj.hasNoCheckScaleState > 0) {
            ElMessage({ message: "运单:"+obj.waybillNumber +" 未客户复测确认,暂不能添加到出库单", type: "warning" });
            return false;
          }
        }

        this.filterDataA.forEach((value) => {
          if (!this.entruckDetailTable.some((m) => m.id === value.id)) {
            let obj = {
              id: value.id,
              documentNumber: value.number,
              documentStatus: value.documentStatus,
              waybillNumber: value.waybillNumber,
              closeNumber: value.closeNumber,
              memberId: value.memberId,
              userMemberName: value.userMemberName,
              boxNo: value.boxNo,
              goodsName: value.goodsName,
              packageName: value.packageName,
              closeBillCount: value.closeBillCount,
              totalCount: value.totalCount,
              totalWeight: value.totalWeight,
              totalVolume: value.totalVolume,
              totalBillingWeight: value.totalBillingWeight,
              entruckNo: value.entruckNo,
              remarks: value.remarks,
              specs: value.specs,
              businessDate: value.businessDate,
            };
            this.entruckDetailTable.push(obj);
          }
        });
        this.waybillShow = false;
      } else {
        this.$message.warning('请选择表格数据');
      }
    },

    // 过滤运单数据
    filterTableA(e) {
      this.filterDataA = e;
    },

    // 分页加载运单数据
    leftPageChangeA(e) {
      this.leftPageDataA.page = e;
      this.onRunPageReportA(this.queryShuttleFrameA);
    },

    // 搜索运单数据
    getSearchA(e) {
      console.info("查询",e)
      let arr = Object.keys(e);
      if (arr.length > 0) {
        let qArr = [];
        for (let i in e) {
          console.info("循环",i)
          if (e[i]) {
            let val = e[i];
            if (val === null || val === undefined) {
              continue; // 跳过无效值
            }
            if (i === "endTime") {
              let times = val.split(" ") || [];
              if (times.length > 1 && times[1] === "00:00:00") {
                times[1] = "23:59:59";
                val = times.join(" ");
              }
            }
            qArr.push({ conditonKey: i, conditonVal: val });
          }
        }
        this.queryShuttleFrameA = qArr;
        this.onRunPageReportA(qArr);
      }
    },

    // 运单表格数据选中
    handleDispatchDetailsChange(val) {
      this.dispatchDetailsMultipleSelection = val;
    },

    // 单选添加运单
    onSingleSelectToAddWaybill() {
      this.singleSelectToAddWaybillVisible = true;
    },

    // 关闭单选添加弹窗
    onCancelSingleSelectToAddWaybill() {
      this.singleSelectToAddWaybillVisible = false;
    },

    // 确认单选添加运单
    onConfirmSingleSelectToAddWaybill(msg) {
      if (msg) {
        let obj = { conditonKey: "waybillNumber", conditonVal: msg };
        Api.runReport({
          conditionReqs: [obj],
          number: "bill_entruck_pack_choose_list"
        }).then((res) => {
          if (res.status === 200) {
            const data = res.data;
            if (data.status === "success") {
              let result = data.result;
              const datas = result.datas;
              if (Array.isArray(datas) && datas.length > 0) {
                if(datas.length === 1){
                  const value = datas[0];
                  if (this.entruckDetailTable.some((m) => m.waybillNumber === value.waybillNumber)) {
                    ElMessage({ message: "运单号已存在", type: "error", duration: 2000 });
                    return false;
                  }
                }
                for (let i = 0; i < datas.length; i++){
                  const value = datas[i];
                  if(value.hasNoCheckScaleState > 0) {
                    ElMessage({ message: "运单未客户复测确认,暂不能添加到出库单", type: "warning" });
                    return false;
                  }
                }
                for (let i = 0; i < datas.length; i++){
                  const value = datas[i];
                  let obj = {
                    id: value.id,
                    documentNumber: value.number,
                    documentStatus: value.documentStatus,
                    waybillNumber: value.waybillNumber,
                    closeNumber: value.closeNumber,
                    memberId: value.memberId,
                    userMemberName: value.userMemberName,
                    boxNo: value.boxNo,
                    goodsName: value.goodsName,
                    packageName: value.packageName,
                    totalCount: value.totalCount,
                    closeBillCount: value.closeBillCount,
                    totalWeight: value.totalWeight,
                    totalVolume: value.totalVolume,
                    totalBillingWeight: value.totalBillingWeight,
                    entruckNo: value.entruckNo,
                    remarks: value.remarks,
                    specs: value.specs,
                    businessDate: value.businessDate,
                    importExportTypeShow: value.importExportTypeShow || null
                  };
                  this.entruckDetailTable.push(obj);
                }
                // this.singleSelectToAddWaybillVisible = false;
                ElMessage({ message: "添加成功", type: "success" });
              } else {
                ElMessage({ message: "没有查询到数据", type: "warning" });
                return false;
              }
            }
          }
        });
      }
    },

    // 移除运单
    onDelEntruckNoInfo() {
      if (this.dispatchDetailsMultipleSelection.length > 0) {
        ElMessageBox.confirm("是否删除选定数据？", "系统提示", {
          confirmButtonText: "确认",
          cancelButtonText: "取消",
          type: "warning"
        }).then(() => {
          this.dispatchDetailsMultipleSelection.forEach((value) => {
            this.entruckDetailTable.forEach((item, index) => {
              if (value.documentNumber === item.documentNumber) {
                this.entruckDetailTable.splice(index, 1);
              }
            });
          });
        }).catch(() => {});
      } else {
        ElMessage({ message: "请选择装载明细表格数据", type: "warning" });
      }
    },

    // 扫描运单
    onEntruckWayBillScan() {
      if (this.dispatchDetailsMultipleSelection.length > 0) {
        const idList = this.dispatchDetailsMultipleSelection.map((item) => item.id);
        ElMessageBox.confirm("是否扫描这些数据？", "系统提示", {
          confirmButtonText: "确认",
          cancelButtonText: "取消",
          type: "warning"
        }).then(() => {
          let params = { billTmsWaybillIds: idList };
          Api.entruckWayBillScan(params).then((res) => {
            if (res.status === 200) {
              const data = res.data;
              ElMessage({ message: data.message, type: data.status });
              this.dispatchDetailsMultipleSelection.forEach((item) => {
                item.isScan = true;
              });
            }
          });
        }).catch(() => {});
      } else {
        ElMessage({ message: "请选择装载明细表格数据", type: "warning" });
      }
    },

    // 取消扫描运单
    onCancelEntruckWayBillScan() {
      if (this.dispatchDetailsMultipleSelection.length > 0) {
        const idList = this.dispatchDetailsMultipleSelection.map((item) => item.id);
        ElMessageBox.confirm("是否取消扫描这些数据？", "系统提示", {
          confirmButtonText: "确认",
          cancelButtonText: "取消",
          type: "warning"
        }).then(() => {
          let params = { billTmsWaybillIds: idList };
          Api.cancelEntruckWayBillScan(params).then((res) => {
            if (res.status === 200) {
              const data = res.data;
              ElMessage({ message: data.message, type: data.status });
              this.dispatchDetailsMultipleSelection.forEach((item) => {
                item.isScan = false;
              });
            }
          });
        }).catch(() => {});
      } else {
        ElMessage({ message: "请选择装载明细表格数据", type: "warning" });
      }
    },

    // 批量添加运单
    piLiangAddWaybill() {
      this.waybillnumberShow = true;
    },

    // 批量添加运单 - 取消
    addPayableCancel_A() {
      this.waybillnumberShow = false;
    },

    // 批量添加运单 - 确认
    addPayableConfirm_A() {
      if (!this.addPLwaybillNumbers.numbers) {
        ElMessage({ message: "请输运单号", type: "error" });
        return false;
      }

      let str = this.addPLwaybillNumbers.numbers;
      let regex = /[^\u4e00-\u9fa5a-zA-Z0-9-]+/g;
      let listCC = str.split(regex).filter((item) => item !== "");

      Api.runReport({
        conditionReqs: [{ conditonKey: "waybillNumbers", conditonVal: JSON.stringify(listCC) }],
        number: "entruck_get_waybill_by_number"
      }).then((res) => {
        let datas = res.data.result?.datas || [];
        if (datas.length > 0) {
          datas.forEach((value) => {
            if (!this.entruckDetailTable.some((m) => m.id === value.id)) {
              let obj = {
                id: value.id,
                documentNumber: value.number,
                documentStatus: value.documentStatus,
                waybillNumber: value.waybillNumber,
                closeNumber: value.closeNumber,
                memberId: value.memberId,
                userMemberName: value.userMemberName,
                boxNo: value.boxNo,
                goodsName: value.goodsName,
                packageName: value.packageName,
                totalCount: value.totalCount,
                closeBillCount: value.closeBillCount,
                totalWeight: value.totalWeight,
                totalVolume: value.totalVolume,
                totalBillingWeight: value.totalBillingWeight,
                entruckNo: value.entruckNo,
                remarks: value.remarks,
                specs: value.specs,
                businessDate: value.businessDate,
              };
              this.entruckDetailTable.push(obj);
            }
          });
          this.addPayableCancel_A();
        }
      }).catch((error) => {
        ElMessageBox.confirm(error.data.message, "系统提示")
            .then(() => {})
            .catch(() => {});
      });
    },

    // 删除财务信息
    delGoods(idx) {
      // this.financialInformationTable.splice(idx, 1);
      if (this.isClickBtns) {
        return false;
      }
      this.isClickBtns = true;
      setTimeout(() => {
        this.isClickBtns = false;
      }, 1000);
      // this.financialInformationTable.splice(idx, 1);
      let ids = this.financialInformationTable[idx].id;
      let param = {
        billFinanceItemIds: [ids],
        entruckId: this.baseInfoObj.entruckId,
      };
      Api.delExamFinanceOut(param).then((res) => {
        ElMessage({
          message: res.data.message || "",
          type: "success",
        });

        // 刷新财务表格
        let objA = {
          conditonKey: "entruckId",
          conditonVal: this.baseInfoObj.entruckId,
        };
        this.onGetFinancialInformationData(objA);
      });
    },

    // 编辑费用信息
    async onYsfyEditFun(itm, idx) {
      const itmRow = itm.row;
      this.financialInformationIndex = idx;
      this.addPayableInfo = {
        itemId: itmRow.id,
        financeItemServiceId: itmRow.financeItemServiceId,
        itemCategoryId: itmRow.itemCategoryId,
        itemCategoryName: itmRow.itemCategoryName,
        itemServiceId: itmRow.itemServiceId,
        itemServiceName: itmRow.itemServiceName,
        amount: itmRow.amount,
        currency: itmRow.currency,
        currencyId: itmRow.currencyId || "",
        objectStatusConfDictId: itmRow.objectStatusConfDictId + "",
        objectStatus: itmRow.objectStatus,
        objectName: itmRow.objectName,
        objectNameId: itmRow.objectNameId || "",
        objectNumber: itmRow.objectNumber,
        paymentMethodConfDictId: itmRow.paymentMethodConfDictId + "",
        paymentMethod: itmRow.paymentMethod,
        remarks: itmRow.remarks,
        createUser: itmRow.createUser,
        updateTime: "",
        files: itmRow.files
      };

      if (utils.jyCheckObjectType(itmRow.files) === "Array") {
        if (itmRow.files.length > 0) {
          for (let obj of itmRow.files) {
            if (obj.fileId) {
              await Api.getFileUrl({ fileName: obj.fileId }).then((res) => {
                let filse = res.data.result || {};
                if (filse.url) {
                  obj.url = filse.url;
                } else {
                  ElMessage({
                    message: "附件地址获取失败",
                    type: "error",
                  });
                }
              });
            }
          }
          this.addPayableInfo.files = itmRow.files;
          this.dialogFileNameLists = itmRow.files;
        } else {
          this.addPayableInfo.files = [];
          this.dialogFileNameLists = [];
        }
      } else {
        this.addPayableInfo.files = [];
        this.dialogFileNameLists = [];
      }

      await this.addPayableVisibleChange(true, 3);
      await this.addPayableVisibleChange(true, 4);
      await this.addPayableVisibleChange(true, 5);
      await this.addPayableVisibleChange(true, 6);
      
      
      this.dialogFileNameLists = itmRow.files;
      this.feiYongTit = "编辑费用";
      this.dialogVisible = true;
      console.info("this.objectStatusDataList",this.objectStatusDataList);
      this.objectNameOptionsList = [];
      this.objectStatusDataList.forEach((item) => {
        if (item.confDictId === itmRow.objectStatusConfDictId+"") {
          console.info("进入查询对象",item.keyType);
          if (item.keyType === "customer:object_status") {
            // 会员
            utils.getSelectData("member_down_list", 9).then((res) => {
              this.objectNameOptions = res.arr;
              this.objectNameOptionsList = res.arr;
              this.objectNameOptionsList.forEach((itemA) => {
                if (itemA.userMemberName === this.addPayableInfo.objectName) {
                  this.addPayableInfo.objectNameId = itemA.userMemberId;
                }
              });
            });
          } else if (item.keyType === "dept:object_status") {
            // 部门
            utils.getSelectData("dept_choose_list", 1).then((res) => {
              this.objectNameOptions = res.arr;
              this.objectNameOptionsList = res.arr;
              this.objectNameOptionsList.forEach((itemA) => {
                if (itemA.storageName === this.addPayableInfo.objectName) {
                  this.addPayableInfo.objectNameId = itemA.storageId;
                }
              });
            });
          }else if (item.keyType === "storage:object_status") {
            // 仓库
            utils.getSelectData("storage_choose_list", 1).then((res) => {
              this.objectNameOptions = res.arr;
              this.objectNameOptionsList = res.arr;
              this.objectNameOptionsList.forEach((itemA) => {
                if (itemA.storageName === this.addPayableInfo.objectName) {
                  this.addPayableInfo.objectNameId = itemA.storageId;
                }
              });
            });
          } else if (item.keyType === "channel:object_status") {
            // 合作商
            utils.getSelectData("partner_channel_choose_list", 1).then((res) => {
              this.objectNameOptions = res.arr;
              this.objectNameOptionsList = res.arr;
              this.objectNameOptionsList.forEach((itemA) => {
                if (itemA.partnerName == this.addPayableInfo.objectName) {
                  this.addPayableInfo.objectNameId = itemA.id;
                }
              });
            });
          } else if (item.keyType === "employee:object_status") {
            // 员工
            utils.getSelectData("employee_choose_list", 1).then((res) => {
              this.objectNameOptions = res.arr;
              this.objectNameOptionsList = res.arr;
              this.objectNameOptionsList.forEach((itemA) => {
                if (itemA.objectName === this.addPayableInfo.objectName) {
                  this.addPayableInfo.objectNameId = itemA.objectId;
                }
              });
            });
          } else if (item.keyType === "ship_airlines:object_status") {
            this.objectNameOptions = res.arr;
            // 航空公司
            utils.getSelectData("ship_airlines_choose_list", 1).then((res) => {
              this.objectNameOptionsList = res.arr;
              this.objectNameOptionsList.forEach((itemA) => {
                if (itemA.companyName === this.addPayableInfo.objectName) {
                  this.addPayableInfo.objectNameId = itemA.id;
                }
              });
            });
          }
        }
      });
    },
    // 添加费用
    onAddFeiYong() {
      utils.oldObjToNewObj(this.addPayableInfo, this.backupFinancialInformationTable);
      utils.getSelectData("item_category_choose_list", 1).then((res) => {
        this.itemcategoryTypeOptions = res.arr;
      });
      this.addPayableInfo.itemCategoryId = "";
      this.addPayableInfo.itemCategoryName = "";
      this.addPayableInfo.currency = "";
      this.dialogFileNameLists = [];
      this.feiYongTit = "添加费用";
      this.dialogVisible = true;
    },

    addPayableCancel () {
      this.dialogVisible = false;
    },
    // 添加费用 - 确认
    addPayableConfirm() {
      if (!this.addPayableInfo.objectStatusConfDictId) {
        ElMessage({ message: "结算对象类型必选", type: "error" });
        return false;
      }
      if (!this.addPayableInfo.objectName) {
        ElMessage({ message: "结算对象必选", type: "error" });
        return false;
      }
      if (!this.addPayableInfo.itemCategoryId) {
        ElMessage({ message: "费项类型必选", type: "error" });
        return false;
      }
      if (!this.addPayableInfo.itemServiceId) {
        ElMessage({ message: "费项必选", type: "error" });
        return false;
      }
      if (!this.addPayableInfo.amount) {
        ElMessage({ message: "金额必填", type: "error" });
        return false;
      }
      if (!this.addPayableInfo.currency) {
        ElMessage({ message: "币种必填", type: "error" });
        return false;
      }
      if (!this.addPayableInfo.paymentMethodConfDictId) {
        ElMessage({ message: "付款方式必选", type: "error" });
        return false;
      }

      if (this.addPayableInfo.files && this.addPayableInfo.files.length > 0) {
        this.addPayableInfo.files.forEach((item, key) => {
          if (item.status === "ready") {
            this.addPayableInfo.files.splice(key, 1);
          }
          item.fileName = "";
          item.fileId = item.name;
        });
      }

      if (this.feiYongTit === "添加费用") {
        if (this.addPayableInfo.files && this.addPayableInfo.files.length > 0) {
          this.addPayableInfo.files.forEach((item, key) => {
            item.fileName = "";
            item.fileId = item.name;
            if (item.status == "ready") {
              this.addPayableInfo.files.splice(key, 1);
            }
          });
          this.addPayableInfo.files.forEach((item, key) => {
            item.fileName = item.name;
            item.fileId = item.name;
          });
        }
        let arrs = [this.addPayableInfo];
        this.onSaveCaiwu(JSON.parse(JSON.stringify(arrs)));
        // this.financialInformationTable.push(utils.relObjRam(this.addPayableInfo));
      } else {
        this.addPayableInfo.files.forEach((item, key) => {
          item.fileName = item.name;
          item.fileId = item.name;
        });

        let arrs = [this.addPayableInfo];
        this.onSaveCaiwu(JSON.parse(JSON.stringify(arrs)));

        // utils.oldObjToNewObj(
        //     this.financialInformationTable[this.financialInformationIndex],
        //     utils.relObjRam(this.addPayableInfo)
        // );
      }
    },


    // 财务保存
    async onSaveCaiwu (lists) {
      console.log("lists", lists);
      // let lists = this.financialInformationTable;
      let obj = {
        entruckId: this.baseInfoObj.entruckId,
        financeItems: lists,
      };
      console.log("obj", obj);
      await Api.saveFinance(obj).then((res) => {
        this.dialogVisible = false;
        if (res.status == 200) {
          const data = res.data;
          ElMessage({ message: "保存成功", type: "success" });
          let objA = {
            conditonKey: "entruckId",
            conditonVal: this.baseInfoObj.entruckId,
          };
          // 刷新财务表格
          this.onGetFinancialInformationData(objA);

          if (utils.jyCheckObjectType(data) == "Object") {
            ElMessage({
              message: data.message,
              type: data.status,
            });
          }
        }
      });
    },

    // 文件上传
    dialogChangeFileList(array) {
      if (Array.isArray(array)) {
        this.addPayableInfo.files = array;
        this.dialogFileNameLists = array;
      }
    },
    changeCurrency(val){
      this.currencyOptions.forEach((item) => {
        if (item.cnName === val) {
          this.addPayableInfo.currencyId = item.currencyId;
        }
      });
    },
    // 获取费用数据
    addPayableVisibleChange(val, type) {
      if (val) {
        if (type === 1) {
          utils.getSelectData("object_status", 3).then((res) => {
            this.objectStatusOptions = res.arr;
          });
        } else if (type === 5) {
          utils.getSelectData("", 4).then((res) => {
            this.currencyOptions = res.arr;
          });
        } else if (type === 6) {
          utils.getSelectData("settlement_method", 3).then((res) => {
            this.paymentMethodOptions = res.arr;
          });
        } else if (type === 3) {
          utils.getSelectData("item_category_choose_list", 1).then((res) => {
            this.itemcategoryTypeOptions = res.arr;
          });
        } else if (type === 4) {
          utils.getSelectData("item_service_choose_list", 1, [
            { conditonKey: "itemCategoryId", conditonVal: this.addPayableInfo.itemCategoryId }
          ]).then((res) => {
            this.itemServiceOptions = res.arr;
          });
        }
      }
    },

    // 获取费用类型
    getFeiXiangType() {
      utils.getSelectData("item_category_choose_list", 1).then((res) => {
        let listA = res.arr;
        this.itemcategoryTypeOptions = res.arr;
        listA.forEach((item) => {
          if (item.categoryName === "装柜费项") {
            utils.getSelectData("item_service_choose_list", 1, [
              { conditonKey: "itemCategoryId", conditonVal: item.itemCategoryId }
            ]).then((res) => {
              let listB = res.arr;
              let arrayList = listB.map((itemB) => ({
                financeItemServiceId: "",
                itemCategoryId: item.itemCategoryId,
                itemCategoryName: item.categoryName,
                itemServiceId: itemB.itemServiceId,
                itemServiceName: itemB.title,
                unitPrice: itemB.unitPrice,
                amount: itemB.unitPrice,
                currency: "",
                currencyId: "",
                objectStatusConfDictId: "",
                objectStatus: "",
                objectName: "",
                objectNameId: "",
                objectNumber: "",
                paymentMethodConfDictId: "",
                paymentMethod: "",
                remarks: "",
                createUser: "",
                updateTime: "",
                files: []
              }));
              this.financialInformationTable = JSON.parse(JSON.stringify(arrayList));
            });
          }
        });
      });
    },

    // 返回对象数据
    returnObjectData(objectInfo, objectStatusOptions, objectNameOptions) {
      this.addPayableInfo.objectStatus = objectInfo.objectStatus;
      this.addPayableInfo.objectStatusConfDictId = objectInfo.objectStatusId + "";
      this.addPayableInfo.objectName = objectInfo.objectName;
      this.addPayableInfo.objectNumber = objectInfo.objectNumber;
      this.addPayableInfo.objectNameId = objectInfo.objectNameId;
      this.objectStatusDataList = objectStatusOptions;
      this.objectNameOptions = objectNameOptions;
    },

    // 费项类型选择
    onSelectItemCategoryName(val) {
      let arr = this.itemcategoryTypeOptions.filter((value) => value.itemCategoryId === val);
      this.addPayableInfo.itemCategoryName = arr.length > 0 ? arr[0].categoryName : "";
    },

    // 费项选择
    onSelectItemServiceName(val) {
      let arr = this.itemServiceOptions.filter((value) => value.itemServiceId === val);
      this.addPayableInfo.itemServiceName = arr.length > 0 ? arr[0].title : "";
    },

    // 付款方式选择
    onSelectPaymentMethod(val) {
      let arr = this.paymentMethodOptions.filter((value) => value.confDictId === val);
      this.addPayableInfo.paymentMethod = arr.length > 0 ? arr[0].val : "";
    },
    async onRunPageReportA(arr) {
      await Api.runPageReport({
        conditionReqs: arr,
        number: "bill_entruck_pack_choose_list",
        pageStart: this.leftPageDataA.page,
        pageTotal: this.leftPageDataA.size,
      }).then((res) => {
        if (res.status == 200) {
          const data = res.data;
          if (data.status == "success") {
            let result = data.result;
            const datas = result.datas;
            this.leftPageDataA.total = datas.pageCount;
            this.leftPageDataA.size = datas.pageTotal;
            this.leftPageDataA.page = datas.pageStart;
            let tableArr = datas.data;
            if (utils.jyCheckObjectType(tableArr) == "Array") {
              if (tableArr.length > 0) {
                this.tableLeftDataA = tableArr;
              } else {
                this.tableLeftDataA = [];
              }
            } else {
              this.tableLeftDataA = [];
            }
          } else {
            this.tableLeftDataA = [];
          }
        }
      });
    },
    async onOutbound(status){
      const idList = [this.baseInfoForm.entruckId];
      let params = {
        entruckId: idList,
      };
      if (status === "confirm") {
        ElMessageBox.confirm("是否对该单据进行出库确认？", "系统提示", {
          confirmButtonText: "确认",
          cancelButtonText: "取消",
          type: "warning",
        })
            .then(async () => {
              await Api.confirmOutStorage(params).then((res) => {
                if (res.status === 200) {
                  const data = res.data;
                  if (utils.jyCheckObjectType(data) === "Object") {
                    ElMessage({
                      message: data.message,
                      type: data.status,
                    });
                  }
                }
              });

            })
            .catch(() => {});
      } else {
        ElMessageBox.confirm("是否对所选数据进行取消出库？", "系统提示", {
          confirmButtonText: "确认",
          cancelButtonText: "取消",
          type: "warning",
        })
            .then(async () => {
              await Api.cancelOutStorage(params).then((res) => {
                if (res.status === 200) {
                  const data = res.data;
                  if (utils.jyCheckObjectType(data) === "Object") {
                    ElMessage({
                      message: data.message,
                      type: data.status,
                    });
                  }
                }
              });
            })
            .catch(() => {});
      }
    },
    // 审批
    async onCaiwuQdSp(row) {
      if (this.isClickBtns) {
        return false;
      }
      this.isClickBtns = true;
      setTimeout(() => {
        this.isClickBtns = false;
      }, 1000);

      let ids = [];
      if (row) {
        const rowData = row.row;
        console.log("rowData", rowData);
        ids = [rowData.id];
      } else {
        if (this.selectTabledataList.length < 1) {
          ElMessage({
            message: "请选择审核费项",
            type: "warning",
          });
          return false;
        }
        console.log("this.selectTabledataList", this.selectTabledataList);
        ids = this.selectTabledataList.map((item) => {
          return item.id;
        });
      }

      let obj = {
        entruckId: this.baseInfoObj.entruckId,
        billFinanceItemIds: ids,
      };
      console.log("objobjobj", obj);
      await Api.examFinanceOut(obj).then((res) => {
        if (res.status == 200) {
          // 更新财务表格数据
          let objA = {
            conditonKey: "entruckId",
            conditonVal: this.baseInfoObj.entruckId,
          };
          this.onGetFinancialInformationData(objA);
          const data = res.data;
          if (utils.jyCheckObjectType(data) == "Object") {
            ElMessage({
              message: data.message,
              type: data.status,
            });
          }
        }
      });
    },
    // 取消审批
    async onCaiwuQxSp(row) {
      if (this.isClickBtns) {
        return false;
      }
      this.isClickBtns = true;
      setTimeout(() => {
        this.isClickBtns = false;
      }, 1000);

      let ids = [];
      if (row) {
        const rowData = row.row;
        console.log("rowData", rowData);
        if (rowData.id) {
          ids = [rowData.id];
        }
      } else {
        if (this.selectTabledataList.length < 1) {
          ElMessage({
            message: "请选择 取消审核 的费项",
            type: "warning",
          });
          return false;
        }
        ids = this.selectTabledataList.map((item) => {
          return item.id;
        });
      }

      let obj = {
        entruckId: this.baseInfoObj.entruckId,
        billFinanceItemIds: ids,
      };
      await Api.cancelExamFinanceOut(obj).then((res) => {
        if (res.status == 200) {
          const data = res.data;
          let objA = {
            conditonKey: "entruckId",
            conditonVal: this.baseInfoObj.entruckId,
          };
          this.onGetFinancialInformationData(objA);
          if (utils.jyCheckObjectType(data) == "Object") {
            ElMessage({
              message: data.message,
              type: data.status,
            });
          }
        }
      });
    },

    handleSelectionChange (val){
      this.selectTabledataList = val;
    },




  },


}

</script>
<style scoped lang="scss">
@import "@/assets/css/common.scss";
.jy-form-container {
  padding: 20px;
  padding-bottom: 100px;
  background: #fff;
  border-radius: 6px;
}

.form-line {
  margin-top: 20px;
  height: 1px;
  background: #ccc;
}

.tag-container {
  width: 100%;
  display: flex;
  justify-content: flex-end;
}

.tag-list {
  display: flex;
  margin-top: 15px;

  .tag-span {
    width: 80px;
    height: 33px;
    line-height: 33px;
    text-align: center;
    border: 2px dashed red;
    color: red;
    border-radius: 5px;
    font-size: 16px;
    font-weight: bold;
    margin-left: 12px;
  }
}
</style>